import * as React from 'react'
import TextField from '@mui/material/TextField'
import {AdapterDateFns} from '@mui/x-date-pickers/AdapterDateFns'
import {LocalizationProvider} from '@mui/x-date-pickers/LocalizationProvider'
import {DatePicker} from '@mui/x-date-pickers/DatePicker'
import {styled} from '@mui/material/styles'
import {FormControl, InputLabel, Tooltip} from '@mui/material'
import {DateTimePicker} from '@mui/x-date-pickers'
import moment from 'moment'
import {useDispatch} from 'react-redux'
import * as form from '../modules/insurance/healthInsurance/redux/healthInsuranceRedux'
import * as auto from '../modules/insurance/AutoInsurance/redux/autoRedux'
import * as user from '../modules/insurance/healthInsurance/redux/userRedux'
import * as filter from '../redux-commons/FilterRedux/filterRedux'
import * as moto from '../modules/insurance/MotoInsurance/redux/motoRedux'
import * as product from '../modules/insurance/InsuranceProducts/redux/productRedux'
import {CustomInputField} from './InputField'
import {FC, useEffect, useState} from 'react'
import {CustomInputLable} from './SelectField'

type Props = {
  label: string
  showHour?: boolean
  id?: string
  formName?: string
  tabName?: string
  defaultValue?: Date
  required?: boolean
  validateField?: boolean
  datePickerReadOnly?: boolean
  errorText?: string
  handleDateChange?: (date: string) => void
  viewYearOnly?: boolean
  viewMonthYear?: boolean
}

export const InputFieldStyled = styled(TextField)(({theme}) => ({
  width: '100%',

  '& .MuiInputLabel-root': {
    position: 'relative',
    transition: 'none',
    transform: 'none',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    top: '0',
    '& legend': {
      display: 'none',
    },
  },
  '& .MuiOutlinedInput-root': {
    '&:hover': {
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: 'rgba(0, 0, 0, 0.23)',
      },
    },
  },
  '& .MuiInputBase-input': {
    borderRadius: 4,
    position: 'relative',
    backgroundColor: theme.palette.mode === 'light' ? '#fcfcfb' : '#2b2b2b',
    fontSize: 12,
    width: '100%',
    padding: '5px 10px',
    boxSizing: 'border-box',
    height: 'inherit',
    borderRight: 'none',
    transition: theme.transitions.create(['border-color', 'background-color', 'box-shadow']),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
  },
}))

// const DatePickerInput = styled(CustomInputField)(({theme}) => ({
//   width: '100%',
//   '& .MuiInputLabel-root': {
//     lineHeight: 'inherit',
//     },
// }))

export const InputDatePicker: FC<Props> = ({
  label,
  showHour,
  id,
  tabName,
  formName,
  defaultValue,
  required,
  validateField,
  errorText,
  datePickerReadOnly,
  handleDateChange,
  viewMonthYear,
  viewYearOnly,
}) => {
  const [value, setValue] = useState<Date | null>(null)
  const [labelInput, setLabelInput] = useState(label)
  const [inputMaxDate, setInputMaxDate] = useState<Date | undefined>(undefined)
  const dispatch = useDispatch()

  const writeDataForm = (value: any) => {
    if (showHour) {
      value = value ? moment(value).format('YYYY/MM/DD HH:mm') : ''
    } else {
      value = value ? moment(value, 'DD/MM/YYYY').format('YYYY/MM/DD') : ''
    }
    if (handleDateChange) handleDateChange(value)
    if (formName && formName.toLowerCase().includes('formperson')) {
      let data = {
        key: id ? id : '',
        value: value,
        tab: tabName ? tabName : '',
        form: formName,
      }
      dispatch(form.actions.addProductInfo(data))
    } else if (formName && formName.toLowerCase().includes('auto')) {
      let data = {
        key: id ? id : '',
        value: value.trim(),
        tab: tabName ? tabName : '',
        form: formName ? formName : '',
      }
      dispatch(auto.actions.addAutoInfos(data))
    } else if (formName && formName.toLowerCase().includes('moto')) {
      let data = {
        key: id ? id : '',
        value: value.trim(),
        tab: tabName ? tabName : '',
        form: formName ? formName : '',
      }
      dispatch(moto.actions.addMotoInfos(data))
    } else if (
      formName &&
      (formName.toLowerCase().includes('product') ||
        formName.toLowerCase().includes('cargo') ||
        formName.toLowerCase().includes('marine') ||
        formName.toLowerCase().includes('property')||
        formName.toLowerCase().includes('micro'))
    ) {
      let data = {
        key: id ? id : '',
        value: value.trim(),
        tab: tabName ? tabName : '',
        form: formName ? formName : '',
      }
      dispatch(product.actions.addProductInfos(data))
    } else if (formName && formName.toLowerCase().includes('filter')) {
      let data = {
        field: id ? id : '',
        value: value,
        filterForm: formName,
      }
      dispatch(filter.actions.updateFilterInfo(data))
    } else {
      let data = {
        key: id ? id : '',
        value: value ? value : '',
      }
      dispatch(user.actions.addUserInfo(data))
    }
  }

  const handleChangeValue = (newValue: Date | null) => {
    setValue(newValue)
  }

  const handleAcceptData = (data: any) => {
    if (viewYearOnly || viewMonthYear) {
      if (handleDateChange) handleChangeValue(data)
    }
    writeDataForm(data)
  }

  const handleBlur = (e: any) => {
    let formatDate = e.target.value.toLowerCase()
    if (viewMonthYear) {
      if (handleDateChange) handleDateChange(moment(formatDate, 'MM/YYYY').format('YYYY/MM/DD'))
      return
    }
    if (viewYearOnly) {
      if (handleDateChange) handleDateChange(moment(formatDate, 'YYYY').format('YYYY/MM/DD'))
      return
    }
    if (formatDate.includes(' pm') || formatDate.includes(' am')) {
      formatDate = moment(formatDate, 'DD/MM/YYYY h:mm a').toDate()
      writeDataForm(formatDate)
    } else {
      if (formatDate.length == 9) return
      if (formatDate) {
        let test = moment(formatDate, 'DD/MM/YYYY').toDate()
        if (test.toString() == 'Invalid Date') {
          return
        }
      }
      if (id && id.toLowerCase().includes('birthday')) {
        let today = moment().format('DD/MM/YYYY')
        let test = moment(e.target.value).isAfter(today)
        if (test) {
          writeDataForm('')
          setValue(null)
        } else writeDataForm(e.target.value)
      } else writeDataForm(e.target.value)
    }
  }

  useEffect(() => {
    if (id && id.toLowerCase().includes('birthday')) {
      setInputMaxDate(moment().toDate())
    }
  }, [id])

  useEffect(() => {
    setValue(defaultValue ? defaultValue : null)
  }, [defaultValue])

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <div className='field-wrapper'>
        <Tooltip
          arrow
          className='tooltip-error-input'
          title={errorText || ''}
          open={validateField && errorText ? true : false}
        >
          <FormControl error={validateField} sx={{width: '100%'}}>
            <CustomInputLable id={labelInput} htmlFor={id} aria-label='test'>
              {labelInput}
              {required && <span className='input-require'> *</span>}
            </CustomInputLable>
            {showHour ? (
              <DateTimePicker
                value={value}
                mask='__/__/____ __:__ _M'
                inputFormat='dd/MM/yyyy hh:mm a'
                onChange={(newValue) => handleChangeValue(newValue)}
                onAccept={(data) => handleAcceptData(data)}
                readOnly={datePickerReadOnly}
                disabled={datePickerReadOnly}
                renderInput={(params) => (
                  <CustomInputField
                    {...params}
                    inputProps={{
                      ...params.inputProps,
                      placeholder: 'Ngày/Tháng/Năm Giờ/Phút',
                    }}
                    error={validateField}
                    onBlur={handleBlur}
                    label={labelInput}
                    fullWidth
                  />
                )}
              />
            ) : (
              <DatePicker
                mask={viewYearOnly ? '____' : viewMonthYear ? '__/____' : '__/__/____'}
                inputFormat={viewYearOnly ? 'yyyy' : viewMonthYear ? 'MM/yyyy' : 'dd/MM/yyyy'}
                value={value}
                views={viewYearOnly ? ['year'] : viewMonthYear ? ['year', 'month'] : undefined}
                onChange={(newValue) => handleChangeValue(newValue)}
                onAccept={(data) => handleAcceptData(data)}
                readOnly={datePickerReadOnly}
                disabled={datePickerReadOnly}
                maxDate={inputMaxDate}
                minDate={moment('01/01/1900', 'DD/MM/YYYY').toDate()}
                renderInput={(params) => (
                  <CustomInputField
                    {...params}
                    inputProps={{
                      ...params.inputProps,
                      placeholder: viewYearOnly ? 'YYYY' : viewMonthYear ? 'MM/YYYY' : 'DD/MM/YYYY',
                    }}
                    onBlur={handleBlur}
                    error={validateField}
                    label={labelInput}
                    fullWidth
                  />
                )}
              />
            )}
          </FormControl>
        </Tooltip>
      </div>
    </LocalizationProvider>
  )
}
